import {
  BasicButton,
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  Modal,
  PrimaryButton,
  Stack,
  Text,
} from "@certn/cascadia-react";
import { Trans, useTranslation } from "react-i18next";

type DeactivateUserModalProps = {
  isOpen: boolean;
  isLoading: boolean;
  onCancel: () => void;
  onConfirm: () => void;
  conflictingBundleTitles?: string[];
  sharedCheckNames?: string[];
};

export function BundleConflictModal(props: DeactivateUserModalProps) {
  const { t } = useTranslation();
  const {
    isOpen,
    isLoading,
    onConfirm,
    onCancel,
    conflictingBundleTitles = [],
    sharedCheckNames = [],
  } = props;
  const hasConflictDetails =
    conflictingBundleTitles.length > 0 && sharedCheckNames.length > 0;

  return (
    <Modal isOpen={isOpen} testID="bundle-conflict-modal">
      <Dialog>
        <DialogHeader onClose={props.onCancel}>
          {t("Update checks")}
        </DialogHeader>
        <DialogContent>
          {hasConflictDetails ? (
            <Stack gap="space-4">
              <Text style="global/body-primary">
                <Trans>
                  This bundled deal shares checks with a bundle already on the
                  package.
                </Trans>
              </Text>
              <Text style="global/body-primary">
                <strong>
                  <Trans>Shared checks</Trans>:
                </strong>{" "}
                {sharedCheckNames.join(", ")}
              </Text>
              <Text style="global/body-primary">
                <strong>
                  <Trans>Already on package</Trans>:
                </strong>{" "}
                {conflictingBundleTitles.join(", ")}
              </Text>
              <Text style="global/body-primary">
                <Trans>Replace the existing bundled deal with this one?</Trans>
              </Text>
            </Stack>
          ) : (
            <Text style="global/body-primary">
              <Trans>
                This bundled deal includes checks that are already part of
                another selected bundled deal. Would you like apply this bundled
                deal instead?
              </Trans>
            </Text>
          )}
        </DialogContent>
        <DialogFooter>
          <BasicButton size="medium" onPress={onCancel} testID="cancel-button">
            <Trans>Cancel</Trans>
          </BasicButton>
          <PrimaryButton
            type="submit"
            size="medium"
            isLoading={isLoading}
            onPress={() => onConfirm()}
            testID="confirm-button"
          >
            <Trans>Apply Bundled Deal</Trans>
          </PrimaryButton>
        </DialogFooter>
      </Dialog>
    </Modal>
  );
}
